export { default as SearchResultRequest } from './result-request';
